
import { computed, onMounted, ref } from 'vue';
import { isEmpty } from 'lodash';
import { NodeType } from '@amplify/amp-module';
import { GetCurrentConversationsList } from '@/constants/getters';
import NodeWrapper from '@/components/graph/common/NodeWrapper';
import GotoPopup from '@/components/graph/popups/GotoPopup';

import { useNodeUtils } from '@/composables/useNodeUtils';
import { useStoreInNodes } from '@/composables/useStoreInNodes';

export default {
  components: { GotoPopup, NodeWrapper },

  setup() {
    const nodeType = NodeType.goTo;

    const { store } = useStoreInNodes();
    const { ampData, uiData, nodeId, nodeRef, canEditAmp, bringNodeToFront, updateDelay } = useNodeUtils({ nodeType });

    const showConversationsPopup = ref(false);

    const isDone = computed(() => !!ampData.value.conversationId);

    const currentConversations = computed(() => store.value.getters[`builderStore/${GetCurrentConversationsList}`]);

    const selectedConversation = computed(() => {
      const { conversationId } = ampData.value;

      return (conversationId && currentConversations.value?.find((conv) => conv.id === conversationId)) || {};
    });

    onMounted(() => {
      if (ampData.value.conversationId && isEmpty(selectedConversation.value)) {
        ampData.value = { ...ampData.value, conversationId: '' };
      }
    });

    const selectConversation = ({ conversation }) => {
      ampData.value.conversationId = conversation.id;
      ampData.value.webLink = '';
      toggleConversationsPopup();
    };

    const onChangeWebLink = (webLink) => {
      ampData.value.webLink = webLink;
      ampData.value.conversationId = '';
    };

    const toggleConversationsPopup = () => {
      if (!canEditAmp.value) {
        return;
      }

      showConversationsPopup.value = !showConversationsPopup.value;

      if (showConversationsPopup) {
        bringNodeToFront();
      }
    };

    return {
      ampData,
      canEditAmp,
      isDone,
      nodeId,
      nodeRef,
      nodeType,
      selectedConversation,
      showConversationsPopup,
      uiData,
      onChangeWebLink,
      selectConversation,
      toggleConversationsPopup,
      updateDelay,
    };
  },
};
